import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("auditiq_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const auth = {
  login: (email, password) => api.post("/auth/login", { email, password }).then(r => r.data),
  register: (payload) => api.post("/auth/register", payload).then(r => r.data),
  me: () => api.get("/auth/me").then(r => r.data),
  saveToken: (t) => localStorage.setItem("auditiq_token", t),
  clear: () => localStorage.removeItem("auditiq_token"),
  token: () => localStorage.getItem("auditiq_token"),
};

export const demoApi = {
  scenarios: () => api.get("/demo/scenarios").then(r => r.data),
  start: (key) => api.post("/demo/start", { scenario_key: key }).then(r => r.data),
};

export const govApi = {
  scan: (url, entity) => api.post("/government/scan", { url, entity_name: entity }).then(r => r.data),
  entities: () => api.get("/government/entities").then(r => r.data),
};

export const budgetApi = {
  documents: (entity) => api.get("/budgets/documents", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
  departments: (entity) => api.get("/budgets/departments", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
  projects: (entity) => api.get("/budgets/capital-projects", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
  vendors: (entity) => api.get("/budgets/vendors", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
  flags: (entity) => api.get("/budgets/risk-flags", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
  analyze: (entity, focus) => api.post("/budgets/analyze", { entity_name: entity, focus_category: focus }).then(r => r.data),
};

export const recApi = {
  list: (entity) => api.get("/recommendations", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
  prioritized: (entity) => api.get("/engine/recommendations/prioritized", { params: entity ? { entity_name: entity } : {} }).then(r => r.data),
};

export const cyberApi = {
  status: () => api.get("/cyber/demo-status").then(r => r.data),
  cyberwater: () => api.get("/cyberwater/status").then(r => r.data),
  scan: () => api.get("/engine/cyber-scan").then(r => r.data),
};

export const contactApi = {
  submit: (payload) => api.post("/contact", payload).then(r => r.data),
};

export const dashApi = {
  summary: () => api.get("/dashboard/summary").then(r => r.data),
  leads: () => api.get("/contact/leads").then(r => r.data),
  audit: () => api.get("/audit-logs").then(r => r.data),
};

export const engineApi = {
  status: () => api.get("/engine/status").then(r => r.data),
  water: () => api.get("/engine/water-production").then(r => r.data),
};

export const certApi = {
  tracks: () => api.get("/certification/tracks").then(r => r.data),
  apply: (payload) => api.post("/certification/apply", payload).then(r => r.data),
};
